package com.islamicmedia.site.components

import androidx.compose.runtime.Composable
import com.islamicmedia.site.theme.*
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*

/**
 * Shown to a library / school account (Entitlement.isLibrary) that has used every search it was
 * granted. A plain notice with one OK button: not an error (so not the error-report dialog) and not
 * a paywall (it cannot subscribe, it asks us for more). Mirrors
 * composeApp/.../components/LibraryOutOfSearchesDialog.kt.
 */
@Composable
fun LibraryOutOfSearchesDialog(message: String, onDismiss: () -> Unit) {
    Div(attrs = {
        onClick { onDismiss() }
        style {
            property("position", "fixed")
            property("inset", "0")
            property("background", "rgba(0,0,0,0.45)")
            property("backdrop-filter", "blur(3px)")
            property("-webkit-backdrop-filter", "blur(3px)")
            display(DisplayStyle.Flex)
            alignItems(AlignItems.Center)
            justifyContent(JustifyContent.Center)
            property("z-index", "1000")
            padding(16.px)
        }
    }) {
        Div(attrs = {
            onClick { it.stopPropagation() }
            style {
                backgroundColor(Color.white)
                borderRadius(24.px)
                padding(28.px, 24.px, 20.px)
                property("max-width", "380px")
                width(100.percent)
                property("box-sizing", "border-box")
                property("box-shadow", CardElevatedShadow)
                display(DisplayStyle.Flex)
                flexDirection(FlexDirection.Column)
                alignItems(AlignItems.Center)
                property("text-align", "center")
            }
        }) {
            P(attrs = {
                style {
                    margin(0.px, 0.px, 10.px)
                    fontSize(20.px)
                    fontWeight(700)
                    property("font-family", TitleFontFamily)
                    property("line-height", "1.3")
                    color(Color("#171717"))
                }
            }) { Text("All searches used") }
            P(attrs = {
                style {
                    margin(0.px)
                    fontSize(14.px)
                    color(Color("#525252"))
                    property("line-height", "1.5")
                }
            }) { Text(message) }
            Button(attrs = {
                onClick { onDismiss() }
                style {
                    marginTop(24.px)
                    backgroundColor(Primary)
                    color(Color.white)
                    property("border", "none")
                    cursor("pointer")
                    fontSize(15.px)
                    fontWeight(600)
                    padding(10.px, 32.px)
                    borderRadius(999.px)
                    property("box-shadow", "0 4px 12px rgba(14, 124, 123, 0.25)")
                }
            }) { Text("OK") }
        }
    }
}
